<template>

  <div id="my-profile-view" class="mb4">
    <div class="mb4">
      <div class="fz24 light mt2">Min profil</div>
      <p class="fz16">Her kan du redigere din personelige informasjon og endre passordet ditt.
      <p/>
    </div>

    <div class="clearfix mxn3">
      <div class="col col-6 px3">
        <div class="bold fz24 mb3">Rediger informasjon</div>
        <div>
          <div class="bold ft2 uppercase mb1">Personlig informasjon</div>

          <md-input-container :class="{'md-input-invalid': errors.hasError('name')}">
            <label>Fullt navn</label>
            <md-input class="md-input-block" v-model="user.name"></md-input>
            <span class="md-error" v-if="errors.hasError('name')">{{ errors.getFirstError('name') }}</span>
          </md-input-container>

          <md-input-container :class="{'md-input-invalid': errors.hasError('email')}">
            <label>E-post</label>
            <md-input class="md-input-block" v-model="user.email" :disabled="true"></md-input>
            <span class="md-error" v-if="errors.hasError('email')">{{ errors.getFirstError('email') }}</span>
          </md-input-container>

          <md-input-container :class="{'md-input-invalid': errors.hasError('phone')}">
            <label>Mobil</label>
            <md-input class="md-input-block" v-model="user.phone"></md-input>
            <span class="md-error" v-if="errors.hasError('phone')">{{ errors.getFirstError('phone') }}</span>
          </md-input-container>

          <md-button class="md-raised md-primary btn-wide m0 p1 px3"
                     @click.native="save()"
                     :disabled="state.is('saving')">Lagre profil
          </md-button>
        </div>
      </div>
      <div class="col col-6 px3">
        <div class="bold fz24 mb3">Endre passord</div>
        <div>
          <div class="bold ft2 uppercase mb1">Ditt personlige passord</div>

          <md-input-container :class="{'md-input-invalid': errors.hasError('password')}">
            <label>Ønsket passord</label>
            <md-input type="password" class="md-input-block" v-model="password.new"></md-input>
            <span class="md-error" v-if="errors.hasError('password')">{{ errors.getFirstError('password') }}</span>
          </md-input-container>

          <md-input-container :class="{'md-input-invalid': errors.hasError('password_confirm')}">
            <label>Gjennta ønsket passord</label>
            <md-input type="password" class="md-input-block" v-model="password.newConfirm"></md-input>
            <span class="md-error" v-if="errors.hasError('password_confirm')">{{ errors.getFirstError('password_confirm') }}</span>
          </md-input-container>

          <md-input-container :class="{'md-input-invalid': errors.hasError('password_old')}">
            <label>Gammelt passord</label>
            <md-input type="password" class="md-input-block" v-model="password.old"></md-input>
            <span class="md-error" v-if="errors.hasError('password_old')">{{ errors.getFirstError('password_old') }}</span>
          </md-input-container>

          <md-button class="md-raised md-primary btn-wide m0 p1 px3"
                      @click.native="savePassword()"
                      :disabled="state.is('saving-password')">
            Endre passord
          </md-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import apiMe from '@/js/api/me';
  import Errors from '@/js/helpers/errors';
  import State from '@/js/helpers/state';

  export default {
    data() {
      return {
        state: new State(),
        errors: new Errors(),
        user: {},
        password: {},
      };
    },

    mounted() {
      apiMe.show()
        .then(this.onFetchSuccess)
        .catch(this.onError);
    },

    methods: {
      save() {
        this.state.start('saving');
        this.errors.clearErrors();

        apiMe.update(this.user)
          .then(this.onSaveSuccess)
          .catch(this.onError)
          .then(() => {
            this.state.stop('saving');
          });
      },

      savePassword() {
        this.state.start('saving-password');
        this.errors.clearErrors();

        const data = {
          password: this.password.new,
          password_confirm: this.password.newConfirm,
          password_old: this.password.old,
        };

        apiMe.update(data)
          .then(this.onUpdatePasswordSuccess)
          .catch(this.onError)
          .then(() => {
            this.state.stop('saving-password');
          });
      },

      onFetchSuccess(response) {
        this.user = response.data.data;
      },

      onSaveSuccess(response) {
        snack('Personlig informasjon oppdatert!');

        this.user = response.data.data;
        this.$root.$data.user = JSON.parse(JSON.stringify(response.data.data));
      },

      onUpdatePasswordSuccess(response) {
        snack('Passord oppdatert!');

        this.password.new = '';
        this.password.newConfirm = '';
        this.password.old = '';
      },

      onError(error) {
        if (error.response !== undefined) {
          this.errors.setErrors(error.response.data.errors);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// MyProfile.vue?864ce838